export const MOBILE_CALENDAR_TOGGLE_EVENT = 'tcg-calendar-toggle-month';
export const MOBILE_CALENDAR_CLOSE_EVENT = 'tcg-calendar-close-month';
export const MOBILE_CALENDAR_STATE_EVENT = 'tcg-calendar-month-state';
export const MOBILE_NAVIGATION_OPEN_EVENT = 'tcg-calendar-open-navigation';
export const MOBILE_OVERLAYS_CLOSE_EVENT = 'tcg-calendar-close-overlays';

const CALENDAR_PATHS = [
  '/',
  '/pokemon-competitions',
  '/onepiece-competitions',
  '/magic-competitions',
  '/riftbound-competitions',
  '/lorcana-competitions',
  '/fleshandblood-competitions',
];

export const isCalendarPath = (pathname: string): boolean => CALENDAR_PATHS.some((path) => (
  path === '/'
    ? pathname === path
    : pathname === path || pathname.startsWith(`${path}/`)
));
